// The portal forwards provider OrderRequirements flags; CC+ has sent them as "true"/"false"
// strings, and a non-empty "false" is truthy.
export function toRequirementFlag(value: unknown): boolean {
  if (typeof value === 'string') {
    return value.trim().toLowerCase() === 'true';
  }
  return value === true;
}
